var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGtot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F7F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 14.5556C17.1746 13.5827 16.5479 13 15.8655 13C14.283 13 13 16.134 13 20C13 23.866 14.283 27 15.8655 27C16.5479 27 17.1746 26.4173 17.6667 25.4444",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 14.5556C17.1746 13.5827 16.5479 13 15.8655 13C14.283 13 13 16.134 13 20C13 23.866 14.283 27 15.8655 27C16.5479 27 17.1746 26.4173 17.6667 25.4444",
    stroke: "#646E85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 20.0001L26.3428 20.0001M24.2777 22.7223L27 20.0001L24.2777 17.2778",
    stroke: "#646E85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtot);
export default __webpack_public_path__ + "static/media/gtot.2e501aa4696087f8909f6b34ca760d64.svg";
export { ForwardRef as ReactComponent };